import { BuoyDrawingPropertyDto } from 'models/mooring';
import { buoyStyle } from './styles';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import { Circle as CircleGeometry } from 'ol/geom';
import { fromLonLat } from 'ol/proj';
import { mapFeature, MapRenderOptions } from '../renderOptions';
import { BuoyGrid } from './transform';

export { BuoyGrid as BuoyMappedForDrawing } from './transform';

type RenderBuoysProps = {
  grid: BuoyGrid[][];
  vectorSource: VectorSource;
  buoys: BuoyDrawingPropertyDto[];
};
export const renderBuoys = ({ grid, vectorSource, buoys }: RenderBuoysProps, renderOptions: MapRenderOptions) => {
  if (!grid || grid.length === 0) return;

  for (const row of grid) {
    if (!row || row.length === 0) continue;

    for (const column of row) {
      if (!column || !column.Center) continue;

      const buoy = buoys.find((b) => b.Id === column.Id);
      if (!buoy) continue;

      const buoyPoint = fromLonLat(column.Center);
      const buoyFeature = new Feature({
        geometry: new CircleGeometry(buoyPoint, column.Diameter / (renderOptions?.largeBuoys ? 1 : 2)),
        type: mapFeature.buoy,
        id: column.Id,
      });

      const label = buoy.AnalysisNo ?? '';

      buoyFeature.setStyle((_, res) => buoyStyle(label, res, buoy.IsLightBuoy));
      vectorSource.addFeature(buoyFeature);
    }
  }
};
